import PropTypes from 'prop-types'
import React from 'react'
import { MultiTextLinkWrapper } from './component.styles'
import PipeIcon from '../PipeIcon'
import IconPDF from '../IconPDF'
import TextLink from '../TextLink'

const MultiTextLink = ({
  dataTestId,
  downloadLinkLabel,
  downloadOnClick,
  textLinkLabel,
  textLinkOnClick,
}) => {
  const handleClickAndPreventDefault = (e, handler) => {
    e.preventDefault()
    handler(e)
  }

  if (!downloadLinkLabel && !textLinkLabel) return null

  return (
    <MultiTextLinkWrapper dataTestId={dataTestId}>
      {downloadLinkLabel && (
        <TextLink
          dataTestId="text-link-with-icon"
          href=""
          onClick={e => handleClickAndPreventDefault(e, downloadOnClick)}
        >
          <IconPDF />
          {downloadLinkLabel}
        </TextLink>
      )}
      {downloadLinkLabel && textLinkLabel && <PipeIcon />}
      {textLinkLabel && (
        <TextLink
          dataTestId="text-link"
          href=""
          onClick={e => handleClickAndPreventDefault(e, textLinkOnClick)}
        >
          {textLinkLabel}
        </TextLink>
      )}
    </MultiTextLinkWrapper>
  )
}

MultiTextLink.propTypes = {
  dataTestId: PropTypes.string.isRequired,
  downloadLinkLabel: PropTypes.string,
  downloadOnClick: PropTypes.func,
  textLinkLabel: PropTypes.string,
  textLinkOnClick: PropTypes.func,
}

export default MultiTextLink
